/**
 * Карточка Cloud & DevOps.
 */

import Typewriter from "../Typewriter/Typewriter";
import ServiceCard from "../ServiceCard/ServiceCard";
import IconDevops from "../../assets/icons/IconDevops";
import { SERVICE_DEVOPS } from "../../config/services";

function DevopsCard() {
    const copy = SERVICE_DEVOPS;

    return (
        <ServiceCard variant="devops">
            <div className="group-9__icon group-9__icon_svg group-9__icon_devops" aria-hidden="true">
                <IconDevops />
            </div>
            <h3 className="group-9__title group-9__title_devops">
                <Typewriter text={copy.title} speed={copy.titleSpeed} delay={copy.titleDelay} />
            </h3>
            <p className="group-9__text group-9__text_devops">
                <Typewriter text={copy.text} speed={copy.textSpeed} delay={copy.textDelay} />
            </p>
        </ServiceCard>
    );
}

export default DevopsCard;
// components/ServiceCards/DevopsCard.js
